import { Component, OnInit, ViewChild } from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { SwiperComponent } from 'swiper/angular';
import { BranchService } from 'src/app/services/branch.service';
import { environment } from 'src/environments/environment.prod';

@Component({
	selector: 'app-partner-style-one',

	templateUrl: './partner-style-one.component.html',
})
export class PartnerStyleOneComponent implements OnInit {


	branches: any[] = []
	constructor(public branchService: BranchService) { }

	ngOnInit(): void {


		this.branchService.getAlForSite().subscribe(x => {
			this.branches = x.filter(a => a.showInWebSite == true)
		})
	}

	partnerSlides: SwiperOptions = {
		loop: true,
		pagination: false,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		spaceBetween: 30,
		slidesPerView: 6,
		breakpoints: {
			0: {
				slidesPerView: 2
			},
			576: {
				slidesPerView: 3
			},
			768: {
				slidesPerView: 4
			},
			1200: {
				slidesPerView: 6
			}
		}
	}

	createImgPath = (serverPath?: string) => {
		if (serverPath)
			return `${environment.patchUrl}/${serverPath}`;
	}
}